var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.schema),function(field,key){return _c(field.component,_vm._b({key:key,tag:"component",attrs:{"name":key,"value":_vm.value[key],"hasError":_vm.$v.form[key].$error,"error":_vm.errorMessages[key]},on:{"input":function($event){return _vm.update(key, $event)}}},'component',{...field},false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }